"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundToInterval = roundToInterval;
exports.secondsToMinutes = secondsToMinutes;
exports.formatMinutes = formatMinutes;
var providers_1 = require("../../providers");
function roundToInterval(date, interval) {
    var remainder = interval - (date.getMinutes() % interval);
    return providers_1.dateProvider.addMinutes(date, remainder);
}
function secondsToMinutes(seconds) {
    return seconds / 60;
}
/**
 * Format the time to minutes.
 *
 * @param time number
 *
 * @return number
 */
function formatMinutes(time) {
    var minutes = Math.floor(time);
    var seconds = parseFloat((time % 1).toFixed(2)) * 0.6 * 100;
    return "".concat(minutes, ":").concat(seconds, " min");
}
